<template>
  <div class="ml-3 mr-3">
    <h3 class="mb-2">{{ userLabel }} <span class="text-primary ">{{ points }} Points</span></h3>
    <level-data class="mb-2"
                :level="currentLevel"
                :not-active-points="notActivePoints"
                :active-points="points"
                :total-shipped-orders="totalShippedOrders"
                :total-not-shipped-orders="totalNotShippedOrders"
                :join-date="joinDate"
                :now-date="nowDate"
                :source="source"
    ></level-data>
    <level class="mb-2" :amount-spent="totalShippedOrders" :all-levels="allLevels" :current-level="currentLevel" :source="source"></level>
    <slot></slot>
    <transactions :reward-transactions="rewardTransactions" :source="source"></transactions>
  </div>
</template>

<script>
import Transactions from './transactions/Transactions'
import Level from "./Level";
import LevelData from "./LevelData";
export default {
  name: "RewardIndex",
  props: ['rewardTransactions', 'points', 'allLevels', 'currentLevel', 'totalShippedOrders', 'totalNotShippedOrders', 'activePoints', 'notActivePoints', 'joinDate', 'nowDate', 'source'],
  components: {Transactions, Level, LevelData},
  computed : {
    userLabel() {
      if(this.source == 'Admin') {
        return ""
      } else {
        return 'YOUR REWARDS'
      }
    }
  }
}
</script>

<style scoped>
  .text-primary{
    //color: #00B9E8 !important;
  }
</style>
